import { useMemo } from 'react';
import useQueryString from '../../utils/hooks/useQueryString';

export const useGetBookSearch = ()=>{
    const queryParams = useQueryString();
    
    // queryParams의 정리한다
    return useMemo(() => {
        const defaultQuery = { grade: [], category_general2:[], 
            schoolbook:'', workbook_student:'', workbook_teacher:'', youtube:'', bookcard:'', ebook:'', sort:'createdAt,desc', wish:'',
            search_keyword: '',  page:0, 
        };
        let queryJson = {...defaultQuery, ...queryParams};

        if( typeof queryJson.grade ==='string' )queryJson = {...queryJson, grade:[queryJson.grade]};
        if( typeof queryJson.category_general2==='string' )queryJson = {...queryJson, category_general2:[queryJson.category_general2]};

        // queryJson = {...defaultQuery, ...queryJson};
        queryJson.grade = queryJson.grade.map((val, key)=> parseInt(val ,10) );
        queryJson.category_general2 = queryJson.category_general2.map((val, key)=> parseInt(val, 10) );
        
        return queryJson;
    }, [queryParams]);
}